import { render, staticRenderFns } from "./AnswerNumber.vue?vue&type=template&id=6878d640&"
import script from "./AnswerNumber.vue?vue&type=script&lang=js&"
export * from "./AnswerNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports